import React, { useState } from 'react'
import TabsTwo from '../../../components/general/general-component/tabs/TabsTwo'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import AccountType from './account-type/AccountType'

function AllSettingsAccounting() {
    const { dispatch, langLocal, navigate } = AbstructVar()
    const [type, setType] = useState('account_type')
    const { translate } = AbstructLang()
    const handleSectionClick = (sectionId) => {
        setType(sectionId);
    };
    const tabs = [
        {
            id: 1,
            name: translate('account_type'),
            type: 'account_type',
            icon: 'fa-solid fa-border-all'
        },
        {
            id: 2,
            name: translate('expense_type'),
            type: 'expense_type',
            icon: 'fa-solid fa-border-top-left'
        },
    ]
    return (
        <main>
            <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"}>
                <div className='config-warehouse' >
                    <TabsTwo langLocal={langLocal} tabs={tabs} activeSection={type} handleSectionClick={handleSectionClick} />
                </div>
                <div className='config-warehouse-right'>
                    {
                        type === 'account_type' && (
                            <AccountType />
                        )
                    }
                </div>
            </div>
        </main>
    )
}

export default AllSettingsAccounting